<template>    
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <FormInput class="col-12" label="Nombre" name="Nombre" rules="required" v-model="voucher.name" />
            <FormInput class="col-6" label="Descuento (%)" name="Descuento (%)" type="number" v-model="voucher.discount_percent" :disabled="voucher.discount_fixed != 0" />
            <FormInput class="col-6" label="Descuento (€)" name="Descuento (€)" type="number" v-model="voucher.discount_fixed"  :disabled="voucher.discount_percent != 0" />
            <FormInput class="col-6" label="Código" name="Código" rules="required" v-model="voucher.code" />
            <FormInput class="col-6" label="Usos" name="Usos" rules="required" type="number" v-model="voucher.units" />
            <div class="col-12">
                <div class="form-group">
                    <label for="temporada">Precios</label>
                    <multiselect
                        v-model="voucher.prices"
                        placeholder="Precios"
                        label="descripcion"
                        track-by="id"
                        :options="precios"
                        :multiple="true"
                        class="custom-multiselect"
                    />
                </div>
            </div>
            <b-col cols="12" class="mb-2">
                <b-checkbox v-model="voucher.sin_vincular">El cupón será válido sin necesidad de vincularlo a ninguna zona ni tipo de abono</b-checkbox>
            </b-col>
            <b-col cols="12">
                <b-button type="submit">
                    Continuar
                </b-button>
            </b-col>            
        </div>
    </ValidationObserver>
</template>

<script>
    export default {
        props: {
            voucher: {
                type: Object,
                default: () => { return {}; },
            },
        },
        data() {
            return {
                precios: []
            }
        },
        computed: {
            lista() {
                return this.$store.getters.getListaId;
            }
        },
        created() {
            this.getPrecios();
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.$emit('terminado');
                }
            },
            getPrecios() {
                const params = {
                    lista_id: this.lista
                };

                this.$store.dispatch(this.config.getVuexAlias('back.lista.vouchers.precios.disponibles'), params).then(res => {
                    this.precios = res.data.data;
                });
            }
        }

    }
</script>

<style scoped>
.custom-multiselect .multiselect__content-wrapper {
    z-index: 9999; 
    position: relative; 
}
</style>